import React from 'react';
import { track } from 'shared';
import DownloadImage from 'assets/images/DownloadAppStore.png';

export default function DownloadOnTheAppStoreButton() {
    function handleOnClick() {
        track('App Store Download Button Clicked');
    }
    return (
        <a
            href="https://apps.apple.com/us/app/tandem-babysitting-jobs/id1491607600"
            target="_blank"
            rel="noreferrer"
            onClick={handleOnClick}
        >
            <img
                src={DownloadImage}
                alt="tandem-logo"
                style={{ maxWidth: 200, maxHeight: 75, margin: 0, padding: 0 }}
            />
        </a>
    );
}
